import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { Log } from "@ryde/shared";

// The token is never passed to Log: only the outcome is reported.
export const useApiKeyTokenCopy = (token: string) => {
  const { t } = useTranslation();

  const onCopyClick = useEvent(async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(token);
      Log.infoAndToast(t("apiKey.actions.copied"));
    } catch {
      // clipboard access is refused outside a secure context; the key stays selectable by hand
      Log.warnAndToast(t("apiKey.actions.copyFailed"));
    }
  });

  return { t, onCopyClick };
};
